import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { toCamelCase, toKebabCase, toPascalCase } from '@cli-utils/text.js'
import { afterHook } from '@next-adapter/generators/actions/lifecycle-hook-emissions/after-hook.js'
import { beforeHook } from '@next-adapter/generators/actions/lifecycle-hook-emissions/before-hook.js'
import { lifecycleContext } from '@next-adapter/generators/actions/lifecycle-hook-emissions/lifecycle-context.js'
import { lifecycleHookImport } from '@next-adapter/generators/actions/lifecycle-hook-emissions/lifecycle-hook-import.js'
import { renderGenRestoreContentRenderer } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/gen-restore-content.js'
import { buildRestoreManyToManyStatements } from './build-restore-many-to-many-statements.js'

export function genRestoreContent(ctx: EntityCtx): string {
  const kebabSingular = toKebabCase(ctx.singular)
  const restoreContext = lifecycleContext(
    ctx.plural,
    `,\n      entityId: versionRow.entityId,\n      changedFields: [],\n      metadata: { restoredFromVersion: versionRow.version }`
  )
  const snapshotImport = ctx.hasM2M
    ? `build${ctx.Singular}VersionSnapshotWithRelationships`
    : `build${ctx.Singular}VersionSnapshot`
  const currentSnapshot = ctx.hasM2M
    ? `await build${ctx.Singular}VersionSnapshotWithRelationships(currentRow as unknown as ${ctx.Singular}, tx)`
    : `build${ctx.Singular}VersionSnapshot(currentRow as unknown as ${ctx.Singular})`
  const dbImports = [
    'entityVersions',
    ctx.tableVar,
    ...ctx.m2mFields.map((field) => {
      const rel = field.relationship || ''
      return toCamelCase(`${ctx.singular}${toPascalCase(rel)}`)
    })
  ].sort()
  const restoreM2M = buildRestoreManyToManyStatements(ctx)

  return renderGenRestoreContentRenderer({
    kind: 'renderGenRestoreContentServerActionTemplate',
    props: {
      join: dbImports.join(', '),
      ctxCacheInvalidationFn: ctx.cacheInvalidationFn,
      ctxCamelPlural: ctx.camelPlural,
      ctxSingular: ctx.Singular,
      kebabSingular: kebabSingular,
      snapshotImport: snapshotImport,
      lifecycleHookImport: lifecycleHookImport(),
      ctxPlural: ctx.plural,
      restoreContext: restoreContext,
      beforeHook: beforeHook('beforeRestore', 'lifecycleContext'),
      ctxTableVar: ctx.tableVar,
      currentSnapshot: currentSnapshot,
      restoreM2MContent: restoreM2M ? `\n${restoreM2M}\n` : '',
      afterHookAfterRestore: afterHook(
        'afterRestore',
        renderGenRestoreContentRenderer({
          kind: 'renderGenRestoreContentTemplate',
          props: { ctxSingular: ctx.Singular }
        })
      ),
      ctxCamelSingular: ctx.camelSingular,
      ctxSingularText: ctx.singular
    }
  })
}
